"use client";
import React from 'react';
import '../css/PawsiePage.css';
import '../root.css';
import SEO from '../components/SEO';

function PawsiePage() {
    return (
        <>
            <SEO
                title="Pawsie - Flyer, Instagram Posts & Brand Mascot | Samuel Banczík"
                description="A complete visual identity designed by Samuel Banczík for Pawsie, a Slovak pet sitting platform that connects pet owners with people who want to walk and look after their animals, and brings shelters together to make abandoned pets easier to adopt: a trifold flyer, a set of Instagram posts and an illustrated brand mascot."
                keywords="Pawsie, flyer, trifold, Instagram posts, mascot, branding, graphic design, Samuel Banczík"
                url="https://banczik.com/pawsie"
                type="article"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "name": "Pawsie Project",
                    "url": "https://banczik.com/pawsie",
                    "description": "Pawsie visual identity, showcasing my skills and knowledge in graphic design.",
                    "breadcrumb": {
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
                            { "@type": "ListItem", "position": 2, "name": "Pawsie", "item": "https://banczik.com/pawsie" }
                        ]
                    }
                }}
            />
            <div className='pawsie-container'>
                <div className='pawsie-text'>
                    <div className='pawsie-heading'>
                        <h1><span className='special-font' style={{ fontStyle: "italic" }}>FLYER</span> DESIGN</h1>
                        <img src="/images/pawsie_flyer1.png" alt="Pawsie trifold flyer - outer side with contact details and headline" />
                        <img src="/images/pawsie_flyer2.png" alt="Pawsie trifold flyer - inner side with services and testimonials" />
                        <h1>INSTAGRAM <span className='special-font' style={{ fontStyle: "italic" }}>POSTS</span></h1>
                        <div className='pawsie-posts'>
                            <img src="/images/pawsie1.png" alt="Pawsie Instagram post - premium account discount" />
                            <img src="/images/pawsie2.png" alt="Pawsie Instagram post - introducing the brand mascot" />
                            <img src="/images/pawsie3.png" alt="Pawsie Instagram post - platform launch announcement" />
                            <img src="/images/pawsie4.png" alt="Pawsie Instagram post - try pet ownership with no commitment" />
                            <img src="/images/pawsie5.png" alt="Pawsie Instagram post - helping overcrowded animal shelters" />
                            <img src="/images/pawsie6.png" alt="Pawsie Instagram post - find a pet sitter before your holiday" />
                        </div>
                        <h1>BRAND <span className='special-font' style={{ fontStyle: "italic" }}>MASCOT</span></h1>
                        <img src="/images/doggie2.png" alt="Pawsie brand mascot - illustrated dog" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PawsiePage
